module.exports = __webpack_public_path__ + "img/girl-2.89e344f3.webp";